<template>
  <div class='queryDetails' oncontextmenu='return false' onselectstart ='return false'>
      <!-- 顶部组件 -->
        <top-navigation></top-navigation>
        <!-- 品牌详情内容 -->
        <div class="content">
            <!-- 顶部导航 -->
            <div class="cont_nav">
                <div class="back" @click="back">
                    返回品牌查询
                </div>
            </div>
            <!-- 表单数据 -->
            <el-card class="filter-container" shadow="never" style="margin-top: 15px" v-if="dataReportId">
              <!-- <div style="width: 100%; height: 79vh">
                <tinymce v-model="mangess" height="65vh"/>
              </div> -->
              <h3 class="new_name">{{ calculationData.companyName }}</h3>
              <div style="margin-bottom: 20px">
                <span>1.品牌简介</span>
                <div style="text-indent:2em;margin-top: 15px;line-height: 25px;">
                  {{calculationData.companyDecsription}}
                </div>
              </div>
              <div style="margin-bottom: 20px">
                <span>2. 基础数据与指标结构分析</span>
                <!-- 数据汇总 -->
                <div style="text-indent:2em;margin-top: 15px;line-height: 25px;">
                  {{calculationData.dataRank}}
                </div>
                <div style="text-indent:2em;margin-top: 15px;line-height: 25px;">
                  {{calculationData.synthesisAnalysis}}
                </div>
                <!-- 基础数据与指标结构分析 / 数据总汇 -->
                <el-table
                  :data="calculationData.targetList"
                  border
                  style="margin-top: 15px"
                >
                  <el-table-column
                    :label="companyName"
                    header-align="center"
                    align="center"
                  >
                    <template slot-scope="scope"
                      >目标人群（{{ scope.row.targetDescription }}）</template
                    >
                  </el-table-column>
                  <el-table-column label="知名度" header-align="center" align="center">
                    <el-table-column
                      label="（%）"
                      header-align="center"
                      align="center"
                      prop="popularity"
                    >
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="认知度" header-align="center" align="center">
                    <el-table-column
                      label="（%）"
                      header-align="center"
                      align="center"
                      prop="awareness"
                    >
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="美誉度" header-align="center" align="center">
                    <el-table-column
                      label="（%）"
                      header-align="center"
                      align="center"
                      prop="reputation"
                    >
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="忠诚度" header-align="center" align="center">
                    <el-table-column
                      label="（%）"
                      header-align="center"
                      align="center"
                      prop="loyalty"
                    >
                    </el-table-column>
                  </el-table-column>
                  <el-table-column
                    label="品牌信息量估值"
                    header-align="center"
                    align="center"
                  >
                    <el-table-column
                      label="（万·比特）"
                      header-align="center"
                      align="center"
                      prop="information"
                    >
                    </el-table-column>
                  </el-table-column>
                  <el-table-column
                    label="人均信息量"
                    header-align="center"
                    align="center"
                  >
                    <el-table-column
                      label="（比特/人）"
                      header-align="center"
                      align="center"
                      prop="targetAverageInformation"
                    >
                    </el-table-column>
                  </el-table-column>
                </el-table>
                <div class="biao">
                  表1 {{ calculationData.companyName }}品牌的基础数据表
                </div>

                <div
                  class="echartsBox char"
                  :style="{ height: tableHeight + 'px' }"
                  id="char"
                  ref="char"
                >
                  <div id="main" class="echarts"></div>
                  <table
                    class="echarts_table"
                    border="1"
                    bordercolor="#999"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tr>
                      <th style="width: 150px"></th>
                      <th style="width: 120px">知名度</th>
                      <th>认知度</th>
                      <th>美誉度</th>
                      <th>忠诚度</th>
                    </tr>
                    <tr
                      v-for="(item, index) in calculationData.targetList"
                      :key="index"
                    >
                      <td>
                        <span
                          class="colorBox"
                          :style="{ backgroundColor: item.color.before }"
                        ></span>
                        目标人群（{{ item.newTarget }}）
                      </td>
                      <td>{{ item.popularity }}</td>
                      <td>{{ item.awareness }}</td>
                      <td>{{ item.reputation }}</td>
                      <td>{{ item.loyalty }}</td>
                    </tr>
                  </table>
                  <!-- <div class="keepImg" @click="updown()">
                    <el-tooltip class="item" effect="dark" content="保存图片" placement="bottom">
                      <i class="el-icon-download"></i>
                    </el-tooltip>
                  </div> -->
                </div>
                <div class="biao">
                  图1 {{ calculationData.companyName }}品牌在全国的指标结构图
                </div>
              </div>
              <div style="margin-bottom: 20px">
                <span>3.品牌质量分析</span>
                <div style="text-indent:2em;margin-top: 15px;line-height: 25px;">
                  {{calculationData.dataAnalysis}}
                </div>
                <!-- 品牌质量分析/稳定性计算表 -->
                <el-table
                  :data="calculationData.targetList"
                  border
                  style="width: 100%; margin-top: 15px"
                >
                  <el-table-column label="指标范围" align="center">
                    <template slot-scope="scope"
                      >目标人群（{{ scope.row.targetDescription }}）</template
                    >
                  </el-table-column>
                  <el-table-column
                    prop="informationBasicRate"
                    label="品牌信息基本量的贡献率"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="informationQualityRate"
                    label="品牌信息质的贡献率"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="informationRatio"
                    label="品牌信息质量比值"
                    align="center"
                  ></el-table-column>
                </el-table>
                <div class="biao">
                  表3 {{ calculationData.companyName }}品牌的质量比计算表
                </div>
              </div>
              <div style="margin-bottom: 20px">
                <span>4.品牌信息均值比分析</span>
                <div style="text-indent:2em;margin-top: 15px;line-height: 25px;">
                  {{calculationData.meanAnalysis}}
                </div>
                <el-table
                  :data="calculationData.targetList"
                  border
                  style="width: 100%; margin-top: 15px"
                >
                  <el-table-column :label="companyName" align="center">
                    <template slot-scope="scope">{{
                      scope.row.targetDescription
                    }}</template>
                  </el-table-column>
                  <!-- <el-table-column
                    prop="countryAverageInformation"
                    label="全国人口平均信息量"
                    align="center"
                  >
                  </el-table-column> -->
                  <el-table-column
                    prop="targetAverageInformation"
                    label="目标消费平均信息量"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="averageRatio"
                    label="信息均值比"
                    align="center"
                  >
                  </el-table-column>
                </el-table>
                <div class="biao">
                  表4 {{ calculationData.companyName }}品牌的均值比计算表
                </div>
              </div>
              <div style="margin-bottom: 20px">
                <span>5.品牌信息的稳定性分析</span>
                <div style="text-indent:2em;margin-top: 15px;line-height: 25px;">
                  {{calculationData.brandInfoAnalysis}}
                </div>
                <el-table
                  :data="calculationData.targetList"
                  border
                  style="width: 100%; margin-top: 15px"
                >
                  <el-table-column label="指标范围" align="center">
                    <template slot-scope="scope"
                      >目标人群（{{ scope.row.targetDescription }}）</template
                    >
                  </el-table-column>
                  <el-table-column
                    prop="functionValue"
                    label="N(E)函数值"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="attenuationCoefficient"
                    label="品牌衰减系数"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="attenuationRate"
                    label="品牌信息的衰减速率"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="stabilityIndex"
                    label="品牌稳定性指数"
                    align="center"
                  >
                  </el-table-column>
                </el-table>
                <div class="biao">
                  表5 {{ calculationData.companyName }}品牌的稳定性计算表
                </div>
              </div>
              <div style="margin-bottom: 20px" v-if="calculationData.allAnalysis">
                <span>6.综合分析</span>
                <div style="text-indent:2em;margin-top: 15px;line-height: 25px;">
                  {{calculationData.allAnalysis}}
                </div>
              </div>
            </el-card>

            <!-- 企业信息 -->
            <div  v-else>
              <div class="cont_mage" id="qyxx">
                  <div class="name">
                      <div class="name_img">
                          <img :src="detailsData.logoUrl" alt="">
                      </div>
                      <div class="name_title">{{detailsData.companyName}}</div>
                  </div>
              </div>
              <div class="cont_mage five" v-if="detailsData.companyDecsription != null && detailsData.companyDecsription != ''">
                  <div class="title">
                      <div class="line"></div>
                      <div class="tit_box">品牌介绍</div>
                  </div>
                  <div class="mage_cent" v-html="detailsData.companyDecsription"></div>
              </div>
              <div class="cont_mage four" v-if="detailsData.dataRank != null && detailsData.dataRank != ''">
                  <div class="title">
                      <div class="line"></div>
                      <div class="tit_box">基础数据与指标结构分析</div>
                  </div>
                  <div class="mage_cent" v-html="detailsData.dataRank"></div>
                  <div class="mage_cent" v-html="detailsData.synthesisAnalysis"></div>
              </div>
              <div class="cont_mage three" v-if="detailsData.dataAnalysis != null && detailsData.dataAnalysis != ''">
                  <div class="title">
                      <div class="line"></div>
                      <div class="tit_box">品牌质量分析</div>
                  </div>
                  <div class="mage_cent" v-html="detailsData.dataAnalysis"></div>
              </div>
              <div class="cont_mage two" v-if="detailsData.meanAnalysis != null && detailsData.meanAnalysis != ''">
                  <div class="title">
                      <div class="line"></div>
                      <div class="tit_box">品牌信息均值比分析</div>
                  </div>
                  <div class="mage_cent" v-html="detailsData.meanAnalysis"></div>
              </div>
              <div class="cont_mage one" v-if="detailsData.brandInfoAnalysis != null && detailsData.brandInfoAnalysis != ''">
                  <div class="title">
                      <div class="line"></div>
                      <div class="tit_box">品牌信息的稳定性分析</div>
                  </div>
                  <div class="mage_cent" v-html="detailsData.brandInfoAnalysis"></div>
              </div>
              <div class="cont_mage one" v-if="detailsData.allAnalysis != null && detailsData.allAnalysis != ''">
                  <div class="title">
                      <div class="line"></div>
                      <div class="tit_box">综合分析</div>
                  </div>
                  <div class="mage_cent" v-html="detailsData.allAnalysis"></div>
              </div>
            </div>
        
        </div>
        <!-- footer -->
        <div class="query_footer">
            <div class="footerBox mt">
                <div class="footer_img">
                    <img src="../../assets/image/query/logo_bottom.png" alt="">
                </div>
                <div class="footer_conter">
                    <div class="_conterTop">使用本网站数据应注明数据来源与出处</div>
                    <div class="_conterCet">北京卓闻数据科技有限公司，公司官网：www.zhuowendata.com 登录日期：<span id="Logintime">{{timeLogin}}</span>。</br>
                        本网站数据版权属于“北京卓闻数据科技有限公司”所有（如下简称卓闻数据），卓闻数据支持全国的企业、高校、科研机构的研究者免费使用，但请在使用时务必注明出处，以示您对知识产权创新的尊重。
                    </div>
                </div>
                <div class="footer_right">
                    <div>座机:<span> 010-88801917</span></div>
                    <div>手机:<span> 周先生 13146926876</span></div>
                    <div>地址：北京市石景山区实兴大街30号院7号楼8层88号</div>
                    <div>网址: www.zhuowendata.com</div>
                    <div>京ICP备2021000793号-1</div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import topNavigation from "../../components/topNavigation/topNavigation.vue";
import { reportDetail } from "@/api/brandInquiryA";
import { getCompanyBrandInfo } from "@/api/brandInquiry";

export default {
  components: { topNavigation },
  data() {
    return {
      id: "", // 品牌id
      dataReportId: "", // 计算id
      timeLogin: "", // 登录时间
      detailsData: "", // 品牌数据

      companyName: "", // 品牌名称
      calculationData: "", // 计算详情数据
      tableHeight: "", // echarts高度
      colorList: [
        // echarts 颜色模板
        {before:'#288DF0',after:'#91C5F7'},
        {before:'#91cc75',after:'#C8E5BA'},
        {before:'#fac858',after:'#FCE3AB'},
        {before:'#ee6666',after:'#F7B3B3'},
        {before:'#73c0de',after:'#B9DFEE'},
        {before:'#3ba272',after:'#9CD0B8'},
        {before:'#fc8452',after:'#FEC2A9'},
        {before:'#9a60b4',after:'#B88FCA'},
        {before:'#ea7ccc',after:'#F5BDE6'},
      ],
      seriesData: "", // echarts 柱状图数据
    };
  },
  created() {
    window.scrollTo(0, 0); // 回滚
    this.id = this.$route.query.id;
    this.dataReportId = this.$route.query.dataReportId;
    this.getCompanyBrandInfo();
    this.loginTime();

    this.reportDetail();
    window.onkeydown =
      window.onkeyup =
      window.onkeypress =
        function (event) {
          // 判断是否按下F12，F12键码为123
          if (event.keyCode == 123) {
            event.preventDefault(); // 阻止默认事件行为
            window.event.returnValue = false;
          }
        };
  },
  mounted() {
    // 动态获取echarts高度
    // this.$nextTick(() => {
    //   // this.drawChart();
    //   // let div = document.querySelector(".echarts").clientHeight;
    //   // let divs = document.querySelector(".echarts_table").clientHeight;
    //   // this.tableHeight = div + divs;
    // });
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    // 登录时间
    loginTime() {
      //获取当前时间
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      this.timeLogin = year + "年" + month + "月" + day + "日";
    },
    // 获取品牌详情
    getCompanyBrandInfo() {
      getCompanyBrandInfo({ id: this.id }).then((res) => {
        if (res.code == 200) {
          this.detailsData = res.data;
        }
      });
    },

    // div生成图片
    updown() {
      this.saveImage("char", this.companyName);
    },
    //图片转换格式的方法 直接使用就好  不需要知道为什么
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    /*保存图片的方法（即按钮点击触发的方法）
      第一个参数为需要保存的div的id名
      第二个参数为保存图片的名称 */
    saveImage(divText, imgText) {
      let canvasID = this.$refs[divText];
      let that = this;
      let a = document.createElement("a");
      html2canvas(canvasID).then((canvas) => {
        let dom = document.body.appendChild(canvas);
        dom.style.display = "none";
        a.style.display = "none";
        document.body.removeChild(dom);
        let blob = that.dataURLToBlob(dom.toDataURL("image/png"));
        a.setAttribute("href", URL.createObjectURL(blob));
        //这块是保存图片操作  可以设置保存的图片的信息
        a.setAttribute("download", imgText + ".png");
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(blob);
        document.body.removeChild(a);
      });
    },
    // 获取计算详情
    reportDetail() {
      if (this.dataReportId) {
        reportDetail({ id: this.dataReportId }).then((res) => {
          if (res.code == 200) {
            this.calculationData = res.data;
            this.companyName = this.calculationData.companyName;

            var nem = 11;
            console.log(nem.toString().substr(nem.toString().length - 1, 1));
            // 处理echarts数据
            var newData = [];
            this.calculationData.targetList.forEach((it, index) => {
              // 颜色模块赋值
              if (index < 10) {
                it.color = this.colorList[index];
              } else {
                var newIndex = index
                  .toString()
                  .substr(index.toString().length - 1, 1);
                it.color = this.colorList[newIndex];
              }
              // 数据范围处理
              if (it.targetDescription == "全国") {
                it.newTarget = "全国";
              } else {
                it.newTarget = index;
              }
              // echarts数据赋值
              newData.push(
                // {
                //   data: [
                //     it.popularity,
                //     it.awareness,
                //     it.reputation,
                //     it.loyalty,
                //   ],
                //   color: it.color,
                //   type: "bar",
                // },
                {
                  type: "bar",
                  showBackground: true,
                  barWidth: 30,
                  itemStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        { offset: 0, color: it.color.after },
                        { offset: 0.5, color: it.color.before },
                        { offset: 1, color: it.color.before },
                      ]
                    ),
                  },
                  emphasis: {
                    itemStyle: {
                      color: new this.$echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                          { offset: 0, color: it.color.before },
                          { offset: 0.7, color: it.color.before },
                          { offset: 1, color: it.color.after },
                        ]
                      ),
                    },
                  },
                  data: [
                    it.popularity,
                    it.awareness,
                    it.reputation,
                    it.loyalty,
                  ],
                },

                {
                  type: "line",
                  data: [
                    it.popularity,
                    it.awareness,
                    it.reputation,
                    it.loyalty,
                  ],
                  // color: it.color,
                  smooth: true,
                  itemStyle: {
                    color: new this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        { offset: 0, color: it.color.after },
                        { offset: 0.5, color: it.color.before },
                        { offset: 1, color: it.color.before },
                      ]
                    ),
                  },
                  emphasis: {
                    itemStyle: {
                      color: new this.$echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                          { offset: 0, color: it.color.before },
                          { offset: 0.7, color: it.color.before },
                          { offset: 1, color: it.color.after },
                        ]
                      ),
                    },
                  },
                }
              );
            });
            this.seriesData = newData;
            console.log(this.seriesData);
            this.$nextTick(() => {
              this.drawChart();
              let div = document.querySelector(".echarts").clientHeight;
              let divs = document.querySelector(".echarts_table").clientHeight;
              this.tableHeight = div + divs;
            });
          }
        });
      }
    },
    // echarts 表格生成
    drawChart() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(document.getElementById("main"));
      // 指定图表的配置项和数据
      let option = {
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            max: 100,
            interval: 10,
            axisLabel: {
              formatter: "{value} %",
            },
          },
        ],
        series: this.seriesData,
        // series: [
        //   {
        //     type: "bar",
        //     showBackground: true,
        //     itemStyle: {
        //       color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //         { offset: 0, color: "#83bff6" },
        //         { offset: 0.5, color: "#188df0" },
        //         { offset: 1, color: "#188df0" },
        //       ]),
        //     },
        //     emphasis: {
        //       itemStyle: {
        //         color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //           { offset: 0, color: "#2378f7" },
        //           { offset: 0.7, color: "#2378f7" },
        //           { offset: 1, color: "#83bff6" },
        //         ]),
        //       },
        //     },
        //   },
        // ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
};
</script>

<style scoped lang='less'>
@media screen and (min-width: 0px) and (max-width: 1440px) {
  .mt {
    width: 1440px;
    margin: 0 auto;
  }
  .queryDetails {
    min-width: 1440px;
    .query_nav {
      min-width: 1440px;
      ._navBox {
        padding-left: 5px;
        padding-right: 5px;
        box-sizing: border-box;
      }
    }
  }
}
@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .mt {
    width: 1680px;
    margin: 0 auto;
  }
  .queryDetails {
    min-width: 1680px;
    .query_nav {
      min-width: 1680px;
    }
  }
}
.biao {
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
}
.echartsBox {
  position: relative;
  width: 1200px;
  min-height: 400px;
  margin: 0 auto;
  .keepImg {
    position: absolute;
    left: 80%;
    top: 0;
    font-size: 18px;
    cursor: pointer;
  }
  .echarts {
    width: 600px;
    height: 400px;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
  }
  .echarts_table {
    position: absolute;
    top: 340px;
    left: 50%;
    width: 630px;
    transform: translate(-61.9%, 0);
    border: 1px solid #999;
    border-collapse: collapse; /*设置单元格的边框合并为1*/
    .colorBox {
      width: 10px;
      height: 10px;
      display: inline-block;
      margin-left: 5px;
    }
    td {
      text-align: center;
      border: 1px solid #999;
      border-collapse: collapse; /*设置单元格的边框合并为1*/
    }
    th {
      border: 1px solid #999;
      border-collapse: collapse; /*设置单元格的边框合并为1*/
    }
  }
}
.queryDetails {
  .query_nav {
    // min-width: 1680px;
    height: 84px;
    background: #ffffff;
    box-shadow: 0px 3px 6px 0px #96a1ac;
    ._navBox {
      display: flex;
      justify-content: center;
      padding-top: 18px;
      ._navleft {
        flex: 0.5;
        .img {
          width: 146px;
          height: 47px;
          margin-top: 20px;
        }
      }
      ._navRight {
        flex: 1;
        .right_tabs {
          overflow: hidden;
          ul {
            float: right;
            overflow: hidden;
            margin-right: 34px;
            li {
              float: left;
              padding: 0 22px;
              font-size: 24px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #000000;
              line-height: 51px;
              cursor: pointer;
              a {
                font-size: 24px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #000000;
                margin: 0;
              }
            }
            :nth-child(2) {
              border-bottom: 6px solid #0087fa;
              padding-bottom: 10px;
            }
          }
        }
        .right_btn {
          margin-top: 7px;
          float: right;
          width: 120px;
          height: 36px;
          background: #0087fa;
          border-radius: 7px;
          font-size: 24px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #ffffff;
          line-height: 36px;
          // letter-spacing: 7px;
          text-align: center;
          cursor: pointer;
        }
        :nth-child(1) {
          margin-left: 12px;
        }
      }
    }
  }
  .content {
    margin: 0 auto;
    width: 1200px;
    padding-bottom: 79px;
    .cont_nav {
      width: 1200px;
      margin: 16px auto;
      overflow: hidden;
      .back {
        margin-top: 7px;
        float: left;
        width: 120px;
        height: 36px;
        background: #0087fa;
        border-radius: 7px;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #ffffff;
      }
    }
    .cont_mage {
      width: 1200px;
      margin: 0 auto;
      padding: 16px 12px;
      box-sizing: border-box;
      margin-bottom: 10px;
      .title {
        .line {
          float: left;
          width: 4px;
          height: 18px;
          background: #228ed9;
          border-radius: 2px;
          margin-right: 10px;
          margin-top: 3px;
        }
        .tit_box {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 24px;
        }
      }
      .name {
        overflow: hidden;
        margin-bottom: 12px;
        margin-top: 20px;
        margin-left: 15px;
        .name_img {
          width: 96px;
          height: 56px;
          background: #ffffff;
          border-radius: 4px;
          float: left;
          box-sizing: border-box;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain; //-------------
          }
        }
        .name_title {
          float: left;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #323233;
          line-height: 56px;
          margin-left: 18px;
        }
      }
      .cent {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
        margin-left: 15px;
        margin-bottom: 16px;
      }
      .xinxi {
        margin-left: 15px;
        .xinxi_box {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
          a {
            color: #228ed9;
          }
        }
      }
      .mage_cent {
        margin-left: 15px;
        margin-top: 16px;
      }
    }

    .new_name {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 15px;
    }
  }
  .query_footer {
    width: 100%;
    height: 168px;
    background: #677985;
    display: flex;
    align-items: center;
    justify-content: center;
    .footerBox {
      display: flex;
      align-items: center;
      justify-content: center;
      .footer_img {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 146px;
          height: 47px;
        }
      }
      .footer_conter {
        flex: 1;
        padding-left: 130px;
        ._conterTop {
          font-size: 12px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
          line-height: 18px;
          margin-bottom: 17px;
          margin-left: 30px;
        }
        ._conterCet {
          width: 600px;
          font-size: 10px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
          line-height: 15px;
          -webkit-transform: scale(0.9);
          text-align: left;
        }
      }
      .footer_right {
        flex: 1;
        padding-left: 77px;
        box-sizing: border-box;
        div {
          font-size: 12px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
          line-height: 18px;
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/query/queryDetails.vue